

import { Component } from "@angular/core";
import { Observable, of } from "rxjs";
import { RevenueManagementProperties, Supplier_OficeID,selectRevenueReport,} from "../Models/RevenueManagementProperties";
import { RevenueManagementService } from "../Services/revenue-management.service";
import { Router } from "@angular/router";
import { ActiveSuppliers, Agency_Branches } from "../Models/ActiveClasses";

declare var $;

@Component({
  selector: 'app-revenue-report',
  templateUrl: './revenueReport.component.html',
  styleUrls: ['./revenueReport.component.css']
})
/** BackOfficeAccounts component*/
export class RevenueReportComponent {
  //angForm: FormGroup;
  constructor(public revenueService: RevenueManagementService, private router: Router) { }
  SelectReportObj= new selectRevenueReport();
  collapsed = false;
  revenueManagerList: RevenueManagementProperties[] = [];
  oficeIdList$: Observable<Supplier_OficeID[]>;
  activeSuppliers: ActiveSuppliers[] = [];
  supplierList$: Observable<ActiveSuppliers[]>;
  agency_branchesList$: Observable<Agency_Branches[]>;

  ngOnInit() {
    this.getAgencies();
    this.getSuppliers();
}

  getAgencies(){
    this.revenueService.GetRevenueManagementAgencies_Branches(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.agency_branchesList$ = of(data);
    })
  }

  Edit_Click(data) {
    try {
      if (data.requestType == "Ticket Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "Ticket");
        this.router.navigateByUrl('/revenueManagement');
      }
      else if (data.requestType == "Void Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "Void");
        this.router.navigateByUrl('/voidRevenue');
      }
      else if (data.requestType == "Refund Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "Refund");
        this.router.navigateByUrl('/refundRevenue');
      }
      else if (data.requestType == "ImportPNR Revenue") {
        localStorage.setItem('RevenueManagementListId', data.revenueId);
        localStorage.setItem('RevenueType', "ImportPNR");
        this.router.navigateByUrl('/importRevenue');
      }
      
    }
    catch (e) { }
  }

  LoadButtonClick() {
    this.revenueManagerList = [];
    this.revenueService.GetRevenueReport(this.SelectReportObj).subscribe((data) => {
      this.revenueManagerList = data;
      document.querySelector(".LoadButton").classList.remove("activeLoading");
    });
  }

  getSuppliers() {
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.supplierList$ = of(data);
    })
  }

  ChangeSupplier(SelectedSupplier) {
    try {
        this.revenueService.GetSupplierAllOfficeIds(SelectedSupplier).subscribe((data) => {
          this.oficeIdList$ = of(data);
      })
    }
    catch (e) {
    }
  }

  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
    $(".dx-checkbox-icon").css({ "border": "1px solid black" });
    $(".dx-button-content").css({ "background-color": "var(--first-color-second)" });
    $(".dx-icon.dx-icon-export-to").css({ "color": "white" });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({ "border": "none", "background-color": "#f9f9f9" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
}

